import { SxStyle } from '../../../../types';
import Switch from '@mui/material/Switch';
import { CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import { useSnackbar } from 'notistack';
import { useStringsContext } from '../../../../contexts/strings';
import { Announcement } from '../types';

const styles: SxStyle = {
  switchContainer: {
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'center',
  },
  progress: {
    marginLeft: '8px',
  },
};

interface Props {
  announcement: Announcement;
  onChange: (hidden: boolean) => void;
  isLoading: boolean;
}

const AnnouncementHideSelect = ({ announcement, onChange, isLoading }: Props) => {
  const { strings } = useStringsContext();
  const { enqueueSnackbar } = useSnackbar();

  const onActiveChanged = async (checked: boolean) => {
    try {
      onChange(checked);

      // enqueueSnackbar(message, {
      //   variant: 'success',
      // });
    } catch (error: any) {
      console.error(error);

      enqueueSnackbar(strings.messages.saveError, {
        variant: 'error',
      });
    }
  };

  return (
    <Box sx={styles.switchContainer}>
      {isLoading ? (
        <CircularProgress size={24} sx={styles.progress} />
      ) : (
        <Switch
          size="small"
          checked={!announcement.hidden}
          onChange={(event, checked) => {
            onActiveChanged(!checked);
          }}
        />
      )}
    </Box>
  );
};

export default AnnouncementHideSelect;
